import { ActionContext, ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import { useToast } from 'vue-toastification';
import { RootState } from '..';
import { FiscalYear } from './fiscalYear.model';
import fiscalYearService from './fiscalYear.service';

// namespace
export const FISCALYEAR_STORE_NAMESPACE = 'fiscalYearStore';

// state
interface FiscalYearState {
  fiscalYears: FiscalYear[];
  status: 'init' | 'idle' | 'loading' | 'failed';
}

const initialState: FiscalYearState = {
  fiscalYears: [],
  status: 'init'
};

// mutation
const mutationConstant = {
  FETCH: 'fetch',
  PENDING: 'pending',
  FULFILLED: 'fulfilled',
  REJECTED: 'rejected'
};

const mutation: MutationTree<FiscalYearState> = {
  [mutationConstant.FETCH]: (state: FiscalYearState, fiscalYears: FiscalYear[]) => {
    state.fiscalYears = fiscalYears;
  },
  [mutationConstant.PENDING]: (state: FiscalYearState) => {
    state.status = 'loading';
  },
  [mutationConstant.FULFILLED]: (state: FiscalYearState) => {
    state.status = 'idle';
  },
  [mutationConstant.REJECTED]: (state: FiscalYearState) => {
    state.status = 'failed';
    window.location.href = '/';
  },
};

// action
const toast = useToast();
const actionConstant = {
  FETCH: 'fetch'
};

const action: ActionTree<FiscalYearState, RootState> = {
  [actionConstant.FETCH](context: ActionContext<FiscalYearState, RootState>) {
    return new Promise<void>((resolve, reject) => {
      context.commit(mutationConstant.PENDING);
      fiscalYearService.Fetch()
        .then((response) => {
          context.commit(mutationConstant.FETCH, response.data);
          context.commit(mutationConstant.FULFILLED);
          resolve();
        })
        .catch(() => {
          context.commit(mutationConstant.REJECTED);
          toast.error('ไม่สามารถเรียกข้อมูลได้');
          reject();
        });
    });
  }
};

// getter
const getterConstant = {
  ALL: 'all',
  BY_DATE: 'byDate',
  BY_ID: 'byId',
  STATUS: 'status'
};

const getter: GetterTree<FiscalYearState, RootState> = {
  [getterConstant.ALL]: (state: FiscalYearState) => state.fiscalYears,
  [getterConstant.BY_DATE]: (state: FiscalYearState) => (date: Date) => state.fiscalYears.find(m => m.startDate <= date && m.endDate >= date),
  [getterConstant.BY_ID]: (state: FiscalYearState) => (id: number) => state.fiscalYears.find(m => m.id === id),
  [getterConstant.STATUS]: (state: FiscalYearState) => state.status,
};

// module
const module: Module<FiscalYearState, RootState> = {
  namespaced: true,
  state: initialState,
  mutations: mutation,
  actions: action,
  getters: getter
};

// export
export const FiscalYearGetter = {
  ALL: `${FISCALYEAR_STORE_NAMESPACE}/${getterConstant.ALL}`,
  BY_DATE: `${FISCALYEAR_STORE_NAMESPACE}/${getterConstant.BY_DATE}`,
  BY_ID: `${FISCALYEAR_STORE_NAMESPACE}/${getterConstant.BY_ID}`,
  STATUS: `${FISCALYEAR_STORE_NAMESPACE}/${getterConstant.STATUS}`
};

export const FiscalYearAction = {
  FETCH: `${FISCALYEAR_STORE_NAMESPACE}/${actionConstant.FETCH}`
};

export default module;
